import { render } from "./ReleaseSelector.vue?vue&type=template&id=7d735f6a&scoped=true"
import script from "./ReleaseSelector.vue?vue&type=script&lang=js"
export * from "./ReleaseSelector.vue?vue&type=script&lang=js"

import "./ReleaseSelector.vue?vue&type=style&index=0&id=7d735f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d735f6a"]])

export default __exports__